import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface QuoteSuccessData {
  companyName: string;
}

@Component({
  selector: 'app-quote-success-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quote-success-message.component.html',
  styleUrls: ['./quote-success-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteSuccessMessageComponent {
  @Input() successData!: QuoteSuccessData;

  public isVisible: boolean = true;

  public onCloseClick(): void {
    this.isVisible = false;
    if (window.parent) {
      window.parent.postMessage({
        redirect: false,
        isSubmitted: false,
        closeIframePopup:true
      }, '*');
    }
  }
}
